<template>
    <div class="footer">
        <img style="width: 160px;height: 63px;position: absolute;bottom: 6px;right: 30px" src="../../assets/image/foot_logo.png">
    </div>
</template>

<script>
	export default {

	}
</script>

<style scoped rel="stylesheet/scss" lang="scss" >
    .footer{
        width: 100%;
        height: 72px;
        border-top:1px solid #EEEEEE;
        display: flex;
        align-items: center;
        position: relative;
    }
</style>
